import * as React from 'react';
import { styled } from '@mui/material/styles';
import {default as MuiButton} from '@mui/material/Button';
import "./button.styles.css";

const CustomizedButton = styled(MuiButton)({
  boxShadow: 'none',
  fontFamily: 'var(--font-primary), sans-serif',
  padding: '15px 0',
  fontWeight: 800,
  fontSize: 'var(--text-small-fixed)',
  textTransform: "uppercase",
  width:"100%",
  borderRadius: 8,
  backgroundColor: 'var(--color-button)',
  marginTop: 8,
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: 'var(--color-button)',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'var(--color-button)',
  },
});
export default function Button(props) {
  return (
    <div className='button-container'>
      <CustomizedButton variant="contained" {...props}>
        {props.text}
      </CustomizedButton>
      </div>
  );
}